import { FavoritesBtnType } from '../interfaces'

const FavoritesHeartBtn = ({
  handleAdd,
  handleRemove,
  saved
}: FavoritesBtnType) => {
  return (
    <div className="fav no-print" role="button">
      <button
        onClick={saved ? handleRemove : handleAdd}
        type="button"
        className={saved ? 'fav__btn fav__btn--active' : 'fav__btn'}
        name={saved ? 'remove from favourites' : 'add to favourites'}
      >
        <svg
          className={saved ? 'fav__heart fav__heart--active' : 'fav__heart'}
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 20.792"
          width="24"
          height="20.792"
          aria-hidden="true"
        >
          <path
            transform="translate(-11.9 -14.4)"
            d="M 29.374 14.4 a 6.392 6.392 0 0 0 -5.489 3.172 A 6.328 6.328 0 0 0 18.4 14.4 a 6.807 6.807 0 0 0 -6.5 6.953 a 6.014 6.014 0 0 0 1.159 3.873 c 0.7 1.157 6.371 6.6 9.225 9.315 a 2.364 2.364 0 0 0 3.26 0 c 2.847 -2.713 8.494 -8.155 9.2 -9.312 A 6.065 6.065 0 0 0 35.9 21.353 A 6.811 6.811 0 0 0 29.374 14.4 Z"
          />
        </svg>
      </button>
      <div className="fav__tag">
        <p className="fav__text">
          {saved ? 'REMOVE FROM FAVOURITES' : 'ADD TO FAVOURITES'}
        </p>
      </div>
    </div>
  )
}

export default FavoritesHeartBtn
